import { OwedChip } from 'components';

export type OwedCellProps = {
  value?: number | null;
};

export const OwedCell: React.FC<OwedCellProps> = ({ value }) => {
  return <OwedChip size="small" value={value} />;
};
